import React, { Component } from 'react';
import Gallery from '../Gallery/Gallery';
import FeaturedSpace from '../FeaturedSpace/FeaturedSpace';

export default class Marketing extends Component {
    constructor(props) {
        super(props);
        this.state = {
          showFeatured: false,
          featuredLink: null, 
          featuredTitle: null
        };
        this.handleSelectFeatured = this.handleSelectFeatured.bind(this);
      }
    
    handleSelectFeatured(e, link) {
        let show;
        this.showFeatured ? show=false : show=true;
        this.setState( {
            featuredLink: link,
            showFeatured: show,
        })
    }
    
    render() {
        return (
            <div>
                <br/>
                { !this.state.showFeatured ? (
                    <div className="container marketing">
                        <div>
                            <div className="row">
                                <div className="container">
                                    <img src="https://parameterspace.arup.digital/gh.png" width="100%" alt="loading"/><br/><br/>
                                    <div className="row">
                                        <h1>parameterspace - design option viewer</h1>
                                    </div>
                                </div>
                            </div>
                            <hr className="featurette-divider"></hr>
                                <div>
                                    <Gallery handler={this.handleSelectFeatured.bind(this)}/>
                                    <hr className="featurette-divider"></hr>
                                    <div className="row featurette">
                                        <div className="col-md-7">
                                            <h2 className="featurette-heading">Integrated Workflow <span className="text-muted"> <small>Submit simulations within Grasshopper via <a href="https://eplusplus.arup.digital/">eplusplus</a> and view all permutations online</small></span></h2>
                                            <p className="lead">
                                                Use parameterspace as a standalone design viewer or benefit from eplusplus integration.
                                                Submit your model to the cloud for processing come back and view the results in a way that lets you explore your design options
                                            </p>
                                        </div>
                                        <div className="col-md-5">
                                            <img className="featurette-image img-fluid mx-auto" src="https://parameterspace.arup.digital/stressstrain.png" width="500"></img>
                                        </div>
                                    </div>
                                    <hr className="featurette-divider"></hr>
                                    <div className="row featurette">
                                        <div className="col-md-7 push-md-5">
                                            <h2 className="featurette-heading">Go Faster <span className="text-muted"> <small>Run more simlulations and assess them quicker</small></span></h2>
                                            <p className="lead">Use a graphical interface to flip though design options and evaluate their merit and present them to your clients.</p>
                                        </div>
                                        <div className="col-md-5 pull-md-7">
                                            <img className="featurette-image img-fluid mx-auto" src="https://parameterspace.arup.digital/paarcoords.PNG" width="500"></img>
                                        </div>
                                    </div>
                                    <hr className="featurette-divider"></hr>
                                    <div className="row featurette">
                                        <div className="col-md-7 push-md-5">
                                            <h2 className="featurette-heading">Share directly with your clients<span className="text-muted"> <small>Send the outcomes of your study in a interactive format directly to your client.</small></span></h2>
                                            <p className="lead">The days of munging though outputs and arranging into nice tables for a pdf export are over. Send your client a report you can be proud of at the click of a button</p>
                                        </div>
                                        <div className="col-md-5 pull-md-7">
                                            <img className="featurette-image img-fluid mx-auto" src="https://parameterspace.arup.digital/notifications.PNG" width="500"></img>
                                        </div>
                                    </div>
                                    <hr className="featurette-divider"></hr>
                                </div>
                            </div>
                        </div>
                        ) : <FeaturedSpace link={this.state.featuredLink}/> }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Marketing/Marketing.js